import { Component, OnInit, Input, ChangeDetectorRef } from "@angular/core";

@Component({
  selector: "app-accordion",
  templateUrl: "./accordion.component.html",
  styleUrls: ["./accordion.component.scss"]
})
export class AccordionComponent implements OnInit {
  @Input() title: string;
  @Input() defaultOpened: boolean = false;

  opened = false;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {}

  ngAfterViewInit() {
    this.opened = this.defaultOpened;
    this.cdr.detectChanges();
  }
}
